module.exports = __webpack_public_path__ + "img/discuss_product_requirements.11488dcb.svg";